import React, {useEffect, useState} from "react";
import { ASCII_CODE_A, ASCII_CODE_SMALL_A, CORRECT, FIXED_ANSWER, QUESTION_TYPES, TEXTBOX } from "../../utils/constants";
import {checkUnanswered} from "../../utils/helpers";
import {ReactComponent as CORRECT_ICON} from "../../images/grade-question-correct-icon.svg";
import "../JoinQuizPage/styles.css";

import {LatexInline} from "../../components/Tiptap/latexParser";
import {isGeneralSA} from "../../utils/questionUtils";
import ImageViewer from "../JoinQuizPage/ImageViewer";
import classes from "../JoinQuizPage/ClassResult.module.css";
import {usePPTWebView} from "../../hooks/usePPTWebView";

export default function ViewLiveRespCountChart({
                                                   chartData,
                                                   showCorrectAnswer = false,
                                                   question = {},
                                                   isExpanded,
                                                   isShared,
                                                   notShowAnimation=false,
                                                    }) {

    // const curWindow = useWindowDimensions();
    const {correctAnswers, questionType} = question;
    const [data, setData] = useState([]);
    const [totalData, setTotalData] = useState(0);
    const [correctAnswerIndexArr, setCorrectAnswerIndexArr] = useState([]);
    const {optionsImageMap = {}, weightage, serialNo} = question;
    const gradeEnabled = !!weightage;

    useEffect(() => {
        let optionArrData = [];
        if (!chartData || !Object.entries(chartData).length) {
            if (questionType === QUESTION_TYPES.MCSS.name) {//{"a":"Margin-buying","b":"Overproduction ","c":"Expansion of credit buying","d":"The Dust Bowl "}
                optionArrData = Object.keys(question.optionsMap).sort().map(i => ({index: i.toUpperCase(), value: 0}));
            } else if (questionType === QUESTION_TYPES.CI.name) {//[{"text":"ab","x":0.147369,"y":0.068148,"width":0.310526,"height":0.16},{"text":"b","x":0.511404,"y":0.470617,"width":0.411404,"height":0.206913},{"text":"c","x":0.116667,"y":0.801482,"width":0.297368,"height":0.162468}]

            } else if (questionType === QUESTION_TYPES.TF.name) {//graded poll TF or FITB or MH
                optionArrData.push({index: "True", value: 0});
                optionArrData.push({index: "False", value: 0});
            }
            setData(optionArrData);
            return;
        }


        let tempTotalData = 0;
        const correctAnswerIndexArrCopy = [];
        chartData.forEach((result, index) => {
            if (questionType === QUESTION_TYPES.MCSS.name) {
                optionArrData.push({
                    index: result.indexDisplay,
                    value: result.people,
                    answer: result.ans
                });
            } else if (questionType === QUESTION_TYPES.CI.name) {
                if (result.ans === FIXED_ANSWER.OTHER) {
                    optionArrData.push({value: result.people, answer: FIXED_ANSWER.OTHER});
                } else {
                    optionArrData.push({
                        index: result.indexDisplay,
                        value: result.people,
                        answer: result.ans
                    });
                }
            } else if (questionType === QUESTION_TYPES.TF.name) {
                optionArrData.push({index: result.ans, value: result.people, answer: result.ans});
            } else {
                optionArrData.push({index: result.ans, value: result.people, answer: result.ans});
            }

            if (!!correctAnswers && !!Object.entries(correctAnswers).length) {
                if ((questionType === QUESTION_TYPES.MCSS.name && correctAnswers.includes(optionArrData[index]?.index?.toLowerCase()))
                    || (questionType === QUESTION_TYPES.CI.name && correctAnswers.includes(index))
                    || (questionType === QUESTION_TYPES.TF.name && result.ans.toString().includes(correctAnswers))
                ) {
                    correctAnswerIndexArrCopy.push(index);
                }
            }
            tempTotalData += result.people

        })

        setData(optionArrData);
        setTotalData(tempTotalData);
        setCorrectAnswerIndexArr(correctAnswerIndexArrCopy);
    }, [chartData]);

    const setBar = () => {
        data.forEach((entry, index) => {
            let bar = document.getElementById(`que-${serialNo}-count-bar-${index}`);
            if (!!bar) {
                bar.style.width = `${!!totalData ? (entry.value / totalData) * 100 : 0}%`;
            }
        });
    }

    const resetBar = () => {
        data.forEach((entry, index) => {
            let bar = document.getElementById(`que-${serialNo}-count-bar-${index}`);
            if (!!bar) {
                bar.style.width = "0";
            }
        });
    }

    useEffect(() => {
        if (isExpanded) {
            setBar();
        } else {
            resetBar();
        }
    }, [isExpanded, data, totalData]);

    return (
        <>
            {!!data &&
                <div className={classes.chartContainer} style={{transition: "unset"}}>
                    <div className={classes.chartContainerBody}>
                        {data.map((entry, index) => {
                            const optIdx = String.fromCharCode(ASCII_CODE_SMALL_A + index);

                            let isCorrect = gradeEnabled && !!showCorrectAnswer && correctAnswerIndexArr.includes(index);
                            return (
                                <div key={index} className={classes.countBarContainer}>
                                    <div
                                        id={`que-${serialNo}-count-bar-${index}`}
                                        className={classes.countBar}
                                        style={{transition: notShowAnimation ? "none" : undefined}}
                                        // style={{background: isCorrect ? "#DBE7E1" : undefined}}
                                    />

                                    {/*{questionType !== QUESTION_TYPES.TF.name &&*/}
                                        <div
                                            className={classes.optionIndex}
                                            style={{
                                                background: isCorrect ? "#A1D2BA" : "#DAD0EA",
                                                borderColor: isCorrect ? "#A1D2BA" : "#DAD0EA",
                                            }}
                                        >{questionType !== QUESTION_TYPES.TF.name ? entry.index : ""}</div>
                                    {/*}*/}

                                    {!!optionsImageMap[optIdx]?.imageURL &&
                                        <ImageViewer size={38} imageURL={optionsImageMap[optIdx]?.imageURL}/>
                                    }

                                    {!!entry.answer &&
                                        <span id={`optionText${index}`} style={{position: "relative"}}>
                                            <LatexInline>{entry.answer}</LatexInline>
                                        </span>
                                    }

                                    <span style={{flex: 1}}/>

                                    {isCorrect &&
                                        <span className={classes.correctBadge}><CORRECT_ICON/></span>
                                    }

                                    {isShared &&
                                        <span className={classes.countBadge}>{entry.value}</span>
                                    }

                                </div>
                            );

                        })}
                    </div>
                </div>
            }
        </>
    );
}
